import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { FiTarget, FiEye, FiUsers } from "react-icons/fi";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24 px-4 sm:px-6 lg:px-8`;
const Heading = tw.h1`font-bold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-gray-900 leading-tight`;
const HeadingRow = tw.div`flex flex-col items-center text-center`;
const Text = tw.div`mt-8 text-base text-gray-600 max-w-3xl mx-auto`;

const Section = tw.div`mt-16`;
const SectionGrid = tw.div`grid grid-cols-1 md:grid-cols-2 gap-8 mt-8`;
const SectionCard = tw.div`bg-white rounded-lg shadow-lg p-8`;
const SectionIcon = tw.div`text-primary-500 text-4xl mb-4`;
const SectionTitle = tw.h3`text-xl font-semibold text-gray-900 mb-2`;
const SectionDescription = tw.p`text-gray-600`;

export default () => {
  const mission = {
    icon: <FiTarget />,
    title: "Notre Mission",
    description: "Notre mission est de révolutionner la gestion des visiteurs en offrant des solutions digitales sécurisées, rapides et faciles à utiliser pour les entreprises et leurs visiteurs."
  };
  const vision = {
    icon: <FiEye />,
    title: "Notre Vision",
    description: "Nous aspirons à devenir le leader de la digitalisation de l'accueil en Afrique, en rendant chaque organisation plus sûre et plus accueillante."
  };
  const team = {
    icon: <FiUsers />,
    title: "Notre Équipe",
    description: "Notre équipe est composée d'experts passionnés par la sécurité, l'innovation et l'expérience utilisateur, travaillant ensemble pour offrir le meilleur service."
  };

  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>À Propos de Nous</Heading>
          </HeadingRow>
          <Text>
            <p className="text-center mb-8">
              Découvrez qui nous sommes, notre mission, notre vision et notre équipe.
            </p>
          </Text>

          <Section>
            <SectionGrid>
              <SectionCard>
                <SectionIcon>{mission.icon}</SectionIcon>
                <SectionTitle>{mission.title}</SectionTitle>
                <SectionDescription>{mission.description}</SectionDescription>
              </SectionCard>
              <SectionCard>
                <SectionIcon>{vision.icon}</SectionIcon>
                <SectionTitle>{vision.title}</SectionTitle>
                <SectionDescription>{vision.description}</SectionDescription>
              </SectionCard>
              <SectionCard>
                <SectionIcon>{team.icon}</SectionIcon>
                <SectionTitle>{team.title}</SectionTitle>
                <SectionDescription>{team.description}</SectionDescription>
              </SectionCard>
            </SectionGrid>
          </Section>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}; 